import { render, staticRenderFns } from "./clientRoles.vue?vue&type=template&id=4bcc7e82&scoped=true"
import script from "./clientRoles.vue?vue&type=script&lang=js"
export * from "./clientRoles.vue?vue&type=script&lang=js"
import style0 from "./clientRoles.vue?vue&type=style&index=0&id=4bcc7e82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc7e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bcc7e82')) {
      api.createRecord('4bcc7e82', component.options)
    } else {
      api.reload('4bcc7e82', component.options)
    }
    module.hot.accept("./clientRoles.vue?vue&type=template&id=4bcc7e82&scoped=true", function () {
      api.rerender('4bcc7e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/clientRoles.vue"
export default component.exports